import React, { Component, Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { clearErrors } from '../redux/actions/userActions';
import Common from '../components/Common';

const styles = theme => ({
  ...theme,
  root: {
      flexGrow: 1,
      padding: '24px 48px'
    },
  paddingTop: {
    marginTop: 60
  },
  listItem: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  }
})

class Home extends Component {
    componentDidMount() {
        this.props.clearErrors();
    }

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <Common isDashboard={true} />
        <div className={classes.root}>
          <div className={classes.paddingTop}>
            <Grid container spacing={16}>
              <Grid item sm={12} xs={12}>
                aaaaaa
              </Grid>
            </Grid>
          </div>
        </div>
      </Fragment>
    )
  }
}

Home.propTypes = {
  user: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  user: state.user,
})

const mapActionsToProps = {
  clearErrors,
}

export default connect(mapStateToProps, mapActionsToProps)(withStyles(styles)(Home));
